export enum Tour {
  EVENT_CREATION = 'eventCreation',
  EVENT_CREATION_PENDING = 'eventCreationPending',
  EVENT_CREATION_DONE = 'eventCreationDone',
  STUDIO_CREATION = 'studioCreation',
  STUDIO_CREATION_PENDING = 'studioCreationPending',
  STUDIO_CREATION_DONE = 'studioCreationDone',
}
